import React, { useCallback, useState } from 'react';

// DEPENDENCIES
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';

// GLOBAL VARIABLES
import { BUTTON } from 'defaults.js';
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE, RECORD } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { sidebarActions } from 'actions.js';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';
import Button from 'core/tools/Button';

// GLOBAL FUNCTIONS
import { apiFetch, makePath, modalFunctions } from 'functions';

const STOCK_NUM_VALIDATION = yup
  .string()
  .matches(/^[A-Za-z0-9]*$/, 'Must not contain any spaces or special characters.');

// MAIN COMPONENT
const DailySalesSearch = ({ isNew }) => {

  // REACT ROUTER
  const navigate = useNavigate();

  // REDUX DISPATCH
  const dispatch = useDispatch();

  // STATE
  const [ stockNo, setStockNo ] = useState();
  const [ error, setError ] = useState();

  // CALLBACKS
  const showDialog = useCallback(
    () => {
      modalFunctions.add({
        type: 'confirmation',
        title: 'Vehicle Not Found',
        body: (
          <p className="text-danger">There are no vehicles in your current inventory with Stock # {stockNo}</p>
        ),
        continueButton: {
          label: isNew ? 'Add New' : 'Add Pre-Owned',
          icon: BUTTON.add.icon,
          onClick: () => {
            const pathname = makePath(INTERFACE.inventory, RECORD.add);
            const searchParams = new URLSearchParams({
              new_used: isNew ? 1 : 0,
              stock_num: stockNo
            }).toString();
            navigate(`${pathname}?${searchParams}`);
          }
        }
      })
    },
    [stockNo, isNew, navigate]
  )
  const handleClick = useCallback(
    () => {
      if (!stockNo) return modalFunctions.error('Please enter a Stock #.');
      apiFetch({
        endpoint: makePath(ENDPOINTS.dailySales.listByStockNumber, stockNo),
        params: {
          new_used: isNew ? 1 : 0,
          search_which: 'stock_num'
        },
        loadingMessage: 'Searching inventory',
        onError: showDialog,
        onSuccess: result => {
          dispatch(sidebarActions.toggle('vehicleInfo', result));
        }
      });
    },
    [stockNo, isNew, showDialog, dispatch]
  )

  const validateStockNumber = useCallback(
    async value => {
      setError(undefined);
      try {
        await STOCK_NUM_VALIDATION.validate(value);
      } catch (err) {
        setError(err.message);
      }
    },
    [setError]
  )

  const handleChange = useCallback(
    ({ target: { value } }) => {
      validateStockNumber(value);
      setStockNo(value.toUpperCase());
    },
    [setStockNo, validateStockNumber]
  )

  return (
    <Form.Body.Inline>
      <Form.Control
        placeholder="Stock #"
        value={stockNo}
        onChange={handleChange}
        size="sm"
        formGroup={{
          className: 'd-flex flex-shrink-1 w-100'
        }}
        error={error}
      />
      <Form.Col>
        <Button
          type="submit"
          label="View"
          onClick={handleClick}
          outline
          size="sm"
          disabled={!!error}
        />
      </Form.Col>
    </Form.Body.Inline>
  );
};

export default DailySalesSearch;
